const Plumbing = () => {
  return <h1>Plumbing</h1>;
};

export default Plumbing;
